var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VWrapper',{attrs:{"title":"home.index"}},[_vm._v(" "+_vm._s(_vm.$t('home.welcome'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }